import React, { Component } from 'react'
import { connect } from 'react-redux'
import {delay} from '../Animations/helper'
import BaseInfo from './BaseInfo'
import { GetPlayerWithIndexByNum } from '../../reducers/index'

class GoalInfo extends BaseInfo {
    static defaultProps = {
        width: 300,
        height: 60
    }

    static propTypes = {
        minute: React.PropTypes.number.isRequired
    }
    
    renderContent() {               
        return (<div className="row goalInfo">
                    <div className="col-md-4 col-sm-4">
                        <div className="shirt_container" style={{width: "100%", height: "100%", background: "url(https://pefl.ru/"+this.props.form+") no-repeat center", backgroundSize:"contain"}}>    
                        </div>
                    </div>
                    <div className="col-md-8 col-sm-8 score_container">
                        <div className="row text-center score_info">
                            <span className={this.props.isHome ? "hightlighted" : ""}>{this.props.home}</span> 
                            <span className={this.props.isHome ? "hightlighted" : ""}> {this.props.score.Home}</span> : 
                            <span className={!this.props.isHome ? "hightlighted" : ""}> {this.props.score.Away}</span> 
                            <span className={!this.props.isHome ? "hightlighted" : ""}> {this.props.away}</span>
                        </div>
                        <div className="row text-center scorer_info">
                           {this.props.scorer} ({this.props.minute})
                        </div>
                    </div>
                </div>)
    }
}

function mapStateToProps(state, ownProps) {
    let teamState = ownProps.event.team === 1 ? state.HomeTeam : state.AwayTeam;
    let res = GetPlayerWithIndexByNum(teamState.Players, ownProps.event.player);
    
    return {
        home: state.HomeTeam.Name,
        away: state.AwayTeam.Name,
        score: state.Stats.Score,
        form: ownProps.event.team === 1 ? state.HomeTeam.form : state.AwayTeam.form,
        isHome: ownProps.event.team === 1,
        id: ownProps.id,
        onHide: ownProps.onHide,
        scorer: res.player.Name.LastName,
        minute: ownProps.minute
    };
}

export default connect(mapStateToProps)(GoalInfo)


/** WEBPACK FOOTER **
 ** ./src/components/Info/GoalInfo.js
 **/